// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2018 Psycle Interactive. All rights reserved.

const casestudyData = {
  id: 'storycastle',
  heroImg: 'hero.jpg',
  heroTheme: 'light',
  heroHeadingOne: 'HarperCollins',
  heroHeadingTwo: 'StoryCastle',
  details: [
    {
      title: 'AGENCY',
      items: ['Psycle'],
    },
    {
      title: 'PLATFORM',
      items: ['Dialogflow', 'Firebase', 'Google Assistant'],
    },
    {
      title: 'LAUNCH',
      items: ['June 2018'],
    },
  ],
  heading: 'Award-winning family-focused Google Assistant Action',
  challengeImg: 'challenge.jpg',
  challenge: false,
  footerImg: false,
  solution: [
    'The Action was created to celebrate the launch of the new Kids & Families category for the Google Assistant.',
    'Children can listen to a choice of two stories each day, including classics such as Paddington, The Tiger That Came to Tea, and several David Walliams stories.',
    'The Action, which pioneered the use of Media Responses to play long form audio content, won a <a href="https://www.digitalbookworld.com/single-post/2018/10/02/2018-DBW-Award-Winners" target="_blank">Digital Book Award in 2018</a>.',
  ],
  nextCaseStudy: 'smallfoot',
};

export default casestudyData;
